import * as React from 'react';
import { hideNotification, showFavoritesFoldersList } from '../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectSavedInFolders, selectSavedOfferId, selectUserHasFolders } from '../../selectors';
import { AddButton } from '../../components/AddButton';
export function ChangeFolderButtonContainer(_ref) {
  var showIcon = _ref.showIcon,
      _ref$onChangeFolder = _ref.onChangeFolder,
      onChangeFolder = _ref$onChangeFolder === void 0 ? function () {} : _ref$onChangeFolder,
      _ref$onSaveToFolder = _ref.onSaveToFolder,
      onSaveToFolder = _ref$onSaveToFolder === void 0 ? function () {} : _ref$onSaveToFolder;
  var dispatch = useDispatch();
  var offerIds = useSelector(selectSavedOfferId);
  var savedInFolders = useSelector(selectSavedInFolders);
  var userHasFolders = useSelector(selectUserHasFolders);
  var handleSaveClick = React.useCallback(function () {
    dispatch(hideNotification());
    dispatch(showFavoritesFoldersList({
      offerIds: offerIds
    }));
    onSaveToFolder();
  }, [onSaveToFolder]);
  var handleChangeClick = React.useCallback(function () {
    dispatch(hideNotification());
    dispatch(showFavoritesFoldersList({
      offerIds: offerIds
    }));
    onChangeFolder();
  }, [onChangeFolder]);

  if (!savedInFolders && userHasFolders && showIcon) {
    return /*#__PURE__*/React.createElement(AddButton, {
      text: "\u0421\u043E\u0445\u0440. \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443",
      showIcon: true,
      onClick: handleSaveClick
    });
  }

  return /*#__PURE__*/React.createElement("button", {
    onClick: handleChangeClick
  }, "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C");
}